import {
    CHANGE_TOBA_LIST_STORE_SETTINGS, DELETE_TOBA, FAILED_TO_DELETE_TOBA, RECEIVE_ALL_TOBAS,
    RECEIVE_DELETE_TOBA_RESPONSE, RECEIVE_POST_NEW_TOBA_RESPONSE, TOBAS_LIST_PAGE_SHIFT
} from "../actions";
import _ from "lodash";

const defaultState = {
    selectedTobas: {}, // tobaId: toba
    allTobasSelected: false,
    deleteModalOpen: false,
    tobaFormModalOpen: false,
    selectedAction: '',
    totalDeleteResponsesReceived: 0,
    totalTobasToBeDeleted: 0,
    deleting: false,
    badResponseMsg: '',
    page: '1',
    totalRecords: 0,
    displayAmount: '20',
    totalPaginationBoxes: 0,
    openTobaGroupDetailsModal: false,
    selectedTobaToSeeGroups : ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case RECEIVE_POST_NEW_TOBA_RESPONSE:
            return {
                ...state,
                tobaFormModalOpen: false
            };
        case TOBAS_LIST_PAGE_SHIFT:
            if (action.payload === 'left' && state.page > 1) {
                return {
                    ...state,
                    page: state.page - 1,
                    selectedTobas: {},
                    allTobasSelected: false
                }
            }
            else if (action.payload === 'right' && state.page < state.totalPaginationBoxes) {
                return {
                    ...state,
                    page: state.page + 1,
                    selectedTobas: {},
                    allTobasSelected: false
                }
            }
            else {
                return state
            }
        case RECEIVE_ALL_TOBAS:
            let totalDisplayBoxes = Math.ceil(action.payload.body.totalRecords / parseInt(state.displayAmount));
            let currentPage = parseInt(state.page);
            if(currentPage > totalDisplayBoxes){
                currentPage = totalDisplayBoxes;
            }
            return {
                ...state,
                totalRecords: action.payload.body.totalRecords,
                page: currentPage,
                totalPaginationBoxes: totalDisplayBoxes
            };
        case DELETE_TOBA:
            return {
                ...state,
                totalDeleteResponsesReceived: 0,
                totalTobasToBeDeleted: Object.keys(state.selectedTobas).length,
                deleting: true
            };
        case RECEIVE_DELETE_TOBA_RESPONSE:
            let deleting, totalTobasToBeDeleted, totalDeleteResponsesReceived, deleteModalOpen;
            let selectedTobas =  _.pickBy(state.selectedTobas, e => e.id !== action.payload.body.id) ;
            if(state.totalDeleteResponsesReceived + 1 === state.totalTobasToBeDeleted){
                deleting = false;
                totalTobasToBeDeleted = 0;
                totalDeleteResponsesReceived = 0;
                deleteModalOpen = false;
            }
            else {
                deleting = true;
                totalDeleteResponsesReceived = state.totalDeleteResponsesReceived + 1;
                totalTobasToBeDeleted = state.totalTobasToBeDeleted;
                deleteModalOpen = state.deleteModalOpen
            }
            return {
                ...state,
                deleting: deleting,
                totalDeleteResponsesReceived: totalDeleteResponsesReceived,
                totalTobasToBeDeleted: totalTobasToBeDeleted,
                selectedTobas: selectedTobas,
                deleteModalOpen: deleteModalOpen
            };
        case FAILED_TO_DELETE_TOBA:
            let deletingF, totalTobasToBeDeletedF, totalDeleteResponsesReceivedF;
            if(state.totalDeleteResponsesReceived + 1 === state.totalTobasToBeDeleted){
                deletingF = false;
                totalTobasToBeDeletedF = 0;
                totalDeleteResponsesReceivedF = 0;
            }
            else {
                deletingF = true;
                totalDeleteResponsesReceivedF = state.totalDeleteResponsesReceived + 1;
                totalTobasToBeDeletedF = state.totalTobasToBeDeleted;
            }
            // deletingF (not `deleting`, which only exists in the RECEIVE_DELETE_TOBA_RESPONSE
            // case above but shares this switch's lexical scope) - referencing the wrong name
            // threw a TDZ ReferenceError here, aborting the reducer before the loader/message
            // state below was ever applied. deleteModalOpen is intentionally left untouched
            // (instead of being forced closed) so the modal stays open to show badResponseMsg.
            return {
                ...state,
                deleting: deletingF,
                totalDeleteResponsesReceived: totalDeleteResponsesReceivedF,
                totalTobasToBeDeleted: totalTobasToBeDeletedF,
                badResponseMsg: action.payload.body && action.payload.body.message
                    ? action.payload.body.message
                    : 'Failed to delete TOBA(s).'
            };
        case CHANGE_TOBA_LIST_STORE_SETTINGS:
            return {
                ...state,
                [action.payload.key]: action.payload.value,
                badResponseMsg: ''
            };
        default:
            return state;
    }
};